export default __webpack_public_path__ + "static/media/mercedes-eqc.e8e836a8.png";